/**
 * @file utils.js — Fonctions utilitaires partagées pour le frontend.
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

/**
 * Fusionne les noms de classes via clsx, puis déduplique les classes
 * Tailwind CSS conflictuelles via tailwind-merge.
 * @param {...(string|Object|Array)} inputs - Valeurs de classes acceptées par clsx.
 * @returns {string} Chaîne de classes fusionnée et dédupliquée.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
